import { render, staticRenderFns } from "./Ofp.vue?vue&type=template&id=6fdb5e61&scoped=true&"
import script from "./Ofp.vue?vue&type=script&lang=js&"
export * from "./Ofp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdb5e61",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSheet,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/var/apps/oil/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fdb5e61')) {
      api.createRecord('6fdb5e61', component.options)
    } else {
      api.reload('6fdb5e61', component.options)
    }
    module.hot.accept("./Ofp.vue?vue&type=template&id=6fdb5e61&scoped=true&", function () {
      api.rerender('6fdb5e61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Problem/Steps/Ofp.vue"
export default component.exports